// extracted by mini-css-extract-plugin
export default {"ProgressRing":"ProgressRing__ProgressRing--ig-STpF_","progress":"ProgressRing__progress--ig-wGraC","diagram":"ProgressRing__diagram--ig-edVEm"};